import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "app-channel-inapp",
  "use": "app-channel-inapp-usage",
  "viewBox": "0 0 33 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 33 32\" id=\"app-channel-inapp\"><path d=\"M20.666 20v7.357A3.642 3.642 0 0117.022 31H8.31a3.643 3.643 0 01-3.644-3.643V6.644A3.644 3.644 0 018.31 3h4.356m-8 22h16m1-24a5 5 0 015 5v4a2 2 0 002 2h-14a2 2 0 002-2V6a5 5 0 015-5zM21.666 15a.5.5 0 100 1 .5.5 0 000-1\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/app-channel-inapp.svg
// module id = Je7m
// module chunks = 39 44